import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Reveal from "../components/Reveal";
import { Loader2, Scissors } from "lucide-react";

export default function Barbers() {
  const [barbers, setBarbers] = useState(null);

  useEffect(() => {
    api.get("/barbers").then((r) => setBarbers(r.data)).catch(() => setBarbers([]));
  }, []);

  return (
    <div data-testid="barbers-page" className="pt-32 pb-24 max-w-7xl mx-auto px-5 sm:px-8 min-h-screen">
      <Reveal>
        <div className="label-caps mb-3">The Craftsmen</div>
        <h1 className="font-display text-6xl sm:text-7xl tracking-tighter mb-4">Meet the Barbers</h1>
        <p className="text-gray-400 max-w-xl text-lg">
          Years of experience, an eye for detail and a genuine love of the craft.
        </p>
      </Reveal>

      {barbers === null ? (
        <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" /></div>
      ) : (
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {barbers.map((b, i) => (
            <Reveal key={b.id} delay={i * 0.1}>
              <div data-testid={`barber-card-${b.id}`} className="group">
                <div className="relative overflow-hidden rounded-2xl mb-5">
                  {b.photo ? (
                    <img src={b.photo} alt={b.name} className="w-full h-[420px] object-cover group-hover:scale-105 transition-transform duration-700" />
                  ) : (
                    <div className="w-full h-[420px] bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] flex items-center justify-center">
                      <span className="font-display text-8xl text-[#D4AF37]/40">{(b.name || "?").charAt(0)}</span>
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                </div>
                <h3 className="font-display text-3xl">{b.name}</h3>
                <p className="text-gray-400 mt-2 leading-relaxed">{b.bio}</p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {b.specialties?.map((sp) => (
                    <span key={sp} className="text-xs px-3 py-1 rounded-full border border-[#D4AF37]/30 text-[#D4AF37] flex items-center gap-1">
                      <Scissors className="w-3 h-3" /> {sp}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
